import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cpfFormat',
})
export class CpfFormat implements PipeTransform {
  transform(value: string): any {
    return value.replace(
      /^(\d{3})\D*(\d{3})\D*(\d{3})\D*(\d{2})$/g,
      '$1.$2.$3-$4',
    );
  }
}
